export const IMG_URL = 'https://businesshalacha.nyc3.digitaloceanspaces.com/';
export const FILE_URL = 'https://businesshalacha.nyc3.digitaloceanspaces.com/';
export const FILE_TYPES = {
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  DOCUMENT: 'DOCUMENT',
};
